// extracted by mini-css-extract-plugin
module.exports = {"container":"LocalizationFilter_container__iEWbW"};